import { ClockCounterClockwise } from '@phosphor-icons/react';
import { Card, Flex, message, Space, Table, TableColumnsType } from 'antd';
import { useEffect, useState } from 'react';
import { BalanceList, fetchBalanceLog } from '~/services/pay';
import { G_EmptyStr } from '~/utils/const';
import { formatToDateTime } from '~/utils/date';
import { formatAmount } from '~/utils/function';
import { useUserInfo } from '~/hooks/useUserInfo';
import LoginMask from '~/components/LoginMask';
import { useSEO } from '~/hooks/useSEO';

const BalanceLog = ({isTabItem = false}: {isTabItem?: boolean}) => {
  useSEO({
    title: '消费记录 - 简创AIGC',
    description: '查看您的简创AIGC账户消费记录，包括充值、购买插件等交易信息。',
    keywords: '消费记录, 简创AIGC, 账户余额, 交易记录',
    author: '逗赛科技',
    robots: 'noindex, nofollow',
    ogTitle: '消费记录 - 简创AIGC',
    ogDescription: '查看您的简创AIGC账户消费记录，包括充值、购买插件等交易信息。',
    ogUrl: 'https://jcaigc.cn/balance-log',
    twitterCard: 'summary',
    twitterTitle: '消费记录 - 简创AIGC',
    twitterDescription: '查看您的简创AIGC账户消费记录，包括充值、购买插件等交易信息。'
  });

  const { userInfo } = useUserInfo();
  const [dataSource, serDateaSource] = useState<BalanceList[]>([]);
  const columns: TableColumnsType<BalanceList> = [
    {
      title: '交易详情',
      dataIndex: 'description',
      width: 200,
    },
    {
      title: '积分',
      dataIndex: 'points',
      render: (_, record) => {
        const points = record.points;
        const isNegative = points < 0;
        const formattedPoints = formatAmount(points, {fixed: 3});
        return (
          <>
            {isNegative ? (
              <span className="amount-decrease">{formattedPoints}</span>
            ) : (
              <span className="amount-increase">+{formattedPoints}</span>
            )}
          </>
        );
      },
    },
    {
      title: '交易时间',
      dataIndex: 'optAt',
      render: (_, record) => formatToDateTime(record.optAt),
    },
    {
      title: '订单号',
      dataIndex: 'orderNO',
      render: (_, record) => record.orderNO || G_EmptyStr,
    },
  ];
  const loadData = async () => {
    const { code, data, message: msg } = await fetchBalanceLog();
    if (code !== 0) {
      message.error(msg || '获取消费记录失败，请稍后再试！');
      return;
    }
    serDateaSource(data.logs || []);
  };

  const _Table = () => (
    <Table<BalanceList>
      size="small"
      columns={columns}
      scroll={{ x: true }}
      components={{
        table: (props: any) => <table {...props} style={{ minWidth: '660px' }} />,
      }}
      dataSource={dataSource}
    />
  )
  useEffect(() => {
    userInfo?.id &&loadData();
  }, [userInfo?.id]);
  return (
    <div className={isTabItem ? 'balance-log-page-tab-item' : 'balance-log-page zt-page'}>
      {!userInfo?.id && <LoginMask />}
      {isTabItem ? <><div className="mt-2 balance-log-header">最近充值和消费记录</div><_Table /></> : (
        <Card
          className="zt-container"
          title={
            <Flex justify="space-between" align="center">
              <Space className="text-2xl font-semibold">
                <ClockCounterClockwise weight="bold" size={32} />
                消费记录
              </Space>
            </Flex>
          }
          bordered={false}
        >
          <_Table />
        </Card>
      )}
    </div>
  );
};
export default BalanceLog;